import api from '../index'

export interface User {
  id: number
  username: string
  mobile: string
  avatar?: string
  openid?: string
  unionid?: string
  recommended?: string
  parent_id?: number
  user_team_id?: number
  code: string
  user_type: number
  entry_time?: string
  finish_time?: string
  remark?: string
  higher_level: number
  status: number
  created_at: string
  updated_at: string
}

export interface UserListParams {
  page?: number
  pageSize?: number
  keyword?: string
}

export default {
  // 获取用户列表
  list: (params?: UserListParams) => api.get('users/list', { params }),

  // 获取用户详情
  show: (id: number) => api.get(`users/show/${id}`),
}
